/**
 * Which content type a content_page / content_category story belongs to, for
 * the preview dispatcher (StoryblokPreview RenderedStory). Those two
 * components are shared by every content type, so the type has to come from
 * where the story lives:
 *
 *   - Flat layout (sb1 slugs, content-api StoryblokSlugBuilder): every story
 *     sits directly in its tenant folder and its slug is prefixed
 *     `{ct}--{kind}--…` — e.g. `faq--pg--main--k3x9…`, `card--cat--…`.
 *     Parse: ^(faq|action|card|agreement|actionv2|cms)--(pg|cat|itm|itc|cmp)--
 *   - Nested (legacy) layout: customer/sponsor/tenant/<content-type>/<page>/…,
 *     so the type is full_slug segment [3].
 *
 * The CDN story carries `slug`, but it is optional on the typed shape — fall
 * back to the last full_slug segment (identical for a story).
 */
export interface StorySlugFields {
  slug?: string | null;
  full_slug?: string | null;
}

const SB1_PREFIX = /^(faq|action|card|agreement|actionv2|cms)--(pg|cat|itm|itc|cmp)--/;

export function contentTypeFromStory(story: StorySlugFields | null | undefined): string | undefined {
  if (!story) return undefined;
  const fullSlug = typeof story.full_slug === 'string' ? story.full_slug : '';
  const segs = fullSlug.split('/').filter(Boolean);
  const leaf = typeof story.slug === 'string' && story.slug ? story.slug : segs[segs.length - 1];
  const sb1 = leaf ? SB1_PREFIX.exec(leaf) : null;
  if (sb1) return sb1[1];
  // Legacy nested path. split('/')[3] (not the filtered segs) matches the
  // original dispatcher exactly.
  const legacy = fullSlug.split('/')[3];
  return legacy ? legacy : undefined;
}
